import {gql, useMutation} from '@apollo/client';
import {PullAllModelPortfoliosAndProviders} from '../schema-types/PullAllModelPortfoliosAndProviders';

export const PULL_MODELS_AND_PROVIDERS = gql`
  mutation PullAllModelPortfoliosAndProviders {
    pullAllModelPortfoliosAndProviders {
      ok
    }
  }
`;

export const usePullAllModelPortfoliosAndProviders = () => {
  const [pullAllModelPortfoliosAndProviders, {data}] =
    useMutation<PullAllModelPortfoliosAndProviders>(PULL_MODELS_AND_PROVIDERS);

  return {
    pullAllModelPortfoliosAndProviders,
    data,
  };
};
